/// <amd-module name="Test/TestPlansHubRefresh/TestPlanCloneProgress/Redux/TestPlanCloneProgressActions" />
import { ActionsUnion, createAction } from "redux/Utils/ActionHelper";
import { CloneOperationState } from "./TestPlanCloneProgressContracts";

export const TestPlanCloneProgressActions = {
    /**
     * loadOpId: load opId in the state
     */
    loadOpId: (opId: number) => createAction(TestPlanCloneProgressActionsTypes.loadOpId, { opId }),

    /**
     * loadCloneOpStateSucceeded: Dispatched as Action to update state in reducer
     */
    loadCloneOpStateSucceeded: (state: CloneOperationState) => createAction(TestPlanCloneProgressActionsTypes.loadCloneOpStateSucceeded, { state }),

    /**
     * getCloneOpState: Dispatch to get the state from the opID
     */
    getCloneOpState: (planId: number, opId: number, initialCall?: boolean) =>
        createAction(TestPlanCloneProgressActionsTypes.getCloneOpState, { planId, opId, initialCall })
};

export const enum TestPlanCloneProgressActionsTypes {
    loadCloneOpStateSucceeded = "TestPlanCloneProgressActions/loadCloneOpStateSucceeded",
    getCloneOpState = "TestPlanCloneProgressActions/getCloneOpState",
    loadOpId = "TestPlanCloneProgressActions/loadOpId"
}

export type TestPlanCloneProgressActions = ActionsUnion<typeof TestPlanCloneProgressActions>;
